import { useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import { BaseURL } from "./baseUrl";

interface UseApiHookOptions {
  method?: "get" | "post";
}

const useApiHook = <T,>(url: string, options: UseApiHookOptions = {}) => {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fullUrl = `${BaseURL.defaults.baseURL}${url}`;

  const getAuthToken = (): string | null => {
    return localStorage.getItem("token");
  };

  const getMerchantRef = (): string | null => {
    return localStorage.getItem("active");
  };

  const prepareHeaders = () => {
    const token = getAuthToken();
    const merchantRef = getMerchantRef();

    const headers: Record<string, string> = {};

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    if (merchantRef) {
      headers["merchantRef"] = merchantRef;
    }

    return headers;
  };

  const makeRequest = (payload?: any) => {
    setIsLoading(true);
    const headers = prepareHeaders();
    const method = options.method || "post";

    const requestConfig = {
      method,
      url: fullUrl,
      headers,
      ...(payload && method === "post" ? { data: payload } : {}),
      ...(payload && method === "get" ? { params: payload } : {}),
    };

    return axios(requestConfig)
      .then((response: AxiosResponse) => {
        setData(response?.data);
        setIsLoading(false);
        return response;
      })
      .catch((error: AxiosError) => {
        setIsLoading(false);

        // if (error.response?.status === 401) {
        //   window.location.href = "/";
        // }

        if (error.response?.status === 401) {
          // Only redirect to home if we're on a dashboard route
          const currentPath = window.location.pathname;
          if (currentPath.includes("/dashboard")) {
            window.location.href = "/";
          }
        }

        return error.response;
      });
  };

  return { data, isLoading, makeRequest };
};

export default useApiHook;
